// Current Dropbox-backed test dataset for the 4-track album mixer.
export const albumMixerSongs = [
  {
    id: "jeppi-net",
    title: "Jeppi/Net",
    side: "A",
    sideIndex: 1,
    tracks: [
      { id: "track1", title: "Track 1", url: "https://www.dropbox.com/scl/fi/hflt0eq0z8b9jddh9ct4e/1.mp3?rlkey=f3ndqsxd4r77bodtmsfxndk8r&st=lwi2rmqf&dl=0" },
      { id: "track2", title: "Track 2", url: "https://www.dropbox.com/scl/fi/xqexn3ec0lnq4hivepffp/2.mp3?rlkey=5maivs7cmb006elunzn5o383n&st=s7sk6o05&dl=0" },
      { id: "track3", title: "Track 3", url: "https://www.dropbox.com/scl/fi/l9q75j7g3ckxhmlfmd8hd/3.mp3?rlkey=ui4hdmprr86t5v5pzzv5bk5jl&st=bbcjbzvt&dl=0" },
      { id: "track4", title: "Track 4", url: "https://www.dropbox.com/scl/fi/kspeknwrx7je4ql8kd5n9/4.mp3?rlkey=yvu9z6kji52y6ms6l1tlx4g3k&st=nz4v8x8k&dl=0" },
    ],
  },
  {
    id: "forsmekkur",
    title: "Forsmekkur",
    side: "A",
    sideIndex: 2,
    tracks: [
      { id: "track1", title: "Track 1", url: "https://www.dropbox.com/scl/fi/0gxiy8foct7wc4ety9sjs/1.mp3?rlkey=ypqrnkchwvo3s993s9jpnqdom&st=twoye4dc&dl=0" },
      { id: "track2", title: "Track 2", url: "https://www.dropbox.com/scl/fi/zj6z5l48tu2kete4ievm5/2.mp3?rlkey=070cu7rizalysjvxqj48m0b5u&st=k3vjt449&dl=0" },
      { id: "track3", title: "Track 3", url: "https://www.dropbox.com/scl/fi/436t3f7r180di9rz5jpma/3.mp3?rlkey=04r7g3d7mowsvu1ydsomdl3kl&st=0uzit6ot&dl=0" },
      { id: "track4", title: "Track 4", url: "https://www.dropbox.com/scl/fi/scjf69pu1ngu083y0g0af/4.mp3?rlkey=tsramre7ztxn2udx5nxls2xgf&st=uxylybvp&dl=0" },
    ],
  },
  {
    id: "sturtudrengur",
    title: "Sturtudrengur",
    side: "A",
    sideIndex: 3,
    tracks: [
      { id: "track1", title: "Track 1", url: "https://www.dropbox.com/scl/fi/72wf04peul4p9i1qwpo60/1.mp3?rlkey=1dvgbfdusipi347psm7cyf0xm&st=pkpqek2k&dl=0" },
      { id: "track2", title: "Track 2", url: "https://www.dropbox.com/scl/fi/ograninvnde6zf8txjayb/2.mp3?rlkey=ymecvwo07oky35bdi5sw9ix2x&st=i4murf85&dl=0" },
      { id: "track3", title: "Track 3", url: "https://www.dropbox.com/scl/fi/dreo46i530qa781guwef2/3.mp3?rlkey=rpaj5o7cdzq3j7sf0npjiovo2&st=s0bks9bb&dl=0" },
      { id: "track4", title: "Track 4", url: "https://www.dropbox.com/scl/fi/1fi90cdpjaolfgxvgvpno/4.mp3?rlkey=xbcjrmv2748e96im9sq1i50ir&st=635huu6j&dl=0" },
    ],
  },
  {
    id: "prestur",
    title: "Prestur",
    side: "B",
    sideIndex: 1,
    tracks: [
      { id: "track1", title: "Track 1", url: "https://www.dropbox.com/scl/fi/9g7bokxqpdrgr16r9dvaz/1.mp3?rlkey=7a0mbchhes6a5qg4r0a2mlt6c&st=x5pzqjha&dl=0" },
      { id: "track2", title: "Track 2", url: "https://www.dropbox.com/scl/fi/tl51k4a776np4fd466apz/2.mp3?rlkey=8m03p40hgi2bdskthp09oakut&st=3bmo0f37&dl=0" },
      { id: "track3", title: "Track 3", url: "https://www.dropbox.com/scl/fi/fpuu570d9aihi1yey3gmg/3.mp3?rlkey=paxl3dnexkwb1vkwspmpgxmtw&st=9i90s4me&dl=0" },
      { id: "track4", title: "Track 4", url: "https://www.dropbox.com/scl/fi/a940y5xbkgji1qvy1ycja/4.mp3?rlkey=y95i77mp6pp4cli8ie0r85k68&st=uk7ls9th&dl=0" },
    ],
  },
  {
    id: "gloria",
    title: "Gloria",
    side: "B",
    sideIndex: 2,
    tracks: [
      { id: "track1", title: "Track 1", url: "https://www.dropbox.com/scl/fi/3xc5zi4lxom331go574rz/1.mp3?rlkey=wiqz56rxbr3hiu5murgbitohk&st=ghlgtet4&dl=0" },
      { id: "track2", title: "Track 2", url: "https://www.dropbox.com/scl/fi/ohsyqwffuq5bev9t079n5/2.mp3?rlkey=otso51wid23ciuqyyzgjjd0zt&st=en87r3ds&dl=0" },
      { id: "track3", title: "Track 3", url: "https://www.dropbox.com/scl/fi/jibaxw8ygxmypzzq8nci9/3.mp3?rlkey=bpxxsihbdlkf9kpun1nooys5r&st=s0064tck&dl=0" },
      { id: "track4", title: "Track 4", url: "https://www.dropbox.com/scl/fi/0v3cdudm5bsp5ezqf3dce/4.mp3?rlkey=evs94sdvwhg5ufv96fhdswqxp&st=m3dkwsj7&dl=0" },
    ],
  },
];
